import { render, staticRenderFns } from "./UrunCekComponent.vue?vue&type=template&id=5863219a"
import script from "./UrunCekComponent.vue?vue&type=script&lang=js"
export * from "./UrunCekComponent.vue?vue&type=script&lang=js"
import style0 from "./UrunCekComponent.vue?vue&type=style&index=0&id=5863219a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports